
  <h2 mat-dialog-title>{{data.Name}}</h2>

    <mat-dialog-content>


    <div class="details" style="padding-bottom:10px; max-width:500px">
 
      <div class="container">
        
        <div class="row" style="margin-bottom:20px"> 
            <div class="">{{data.Description}}</div>
        </div> 
 
        <div *ngFor="let url of data.URL">

            <div class="row">

              <div>
                <a href="{{url.URL}}" target="external">{{url.Name}}</a>
              </div>

            </div>

        </div>
 
      </div>

    </div>


  <div class="text-right" style="margin-bottom:20px;">
    <button mat-button [mat-dialog-close]="true" class="btn">Close</button>
  </div>

</mat-dialog-content>
